var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { ChartComponent, chartDefaults, defaultTooltipProps, gridColor, } from "../chart/ChartComponent";
import { getBackGroundPlugin, getColor } from "../utils";
export const barWhiteBackgroundColors = [
    "#376EB4",
    "#6f8cc3",
    "#9cacd2",
    "#c6cee1",
    "#b4a078",
];
export const barDarkBackgroundColors = [
    "rgba(255,255,255,0.8)",
    "#ccd7df",
    "#99b0c0",
    "#6689a0",
    "#b4a078",
];
export const Bar = forwardRef((_a, ref) => {
    var { background = "white", responsive, data, alignment, title, xAxistitle, yAxistitle, y1Axistitle, titlePosition, legendPosition, tooltip, showAxisX = true, showAxisY = true, showAxisY1 = true, showGridX = false, showGridY = false, showGridY1 = false, showLegend = false } = _a, rest = __rest(_a, ["background", "responsive", "data", "alignment", "title", "xAxistitle", "yAxistitle", "y1Axistitle", "titlePosition", "legendPosition", "tooltip", "showAxisX", "showAxisY", "showAxisY1", "showGridX", "showGridY", "showGridY1", "showLegend"]);
    return (_jsx(ChartComponent, Object.assign({}, rest, { responsive: responsive, type: "bar", ref: ref, data: Object.assign(Object.assign({}, data), { datasets: (typeof data !== "function" && !!data.datasets
                ? data.datasets
                : []).map((e, i) => (Object.assign({ backgroundColor: background !== "white"
                    ? getColor(i, barDarkBackgroundColors)
                    : getColor(i, barWhiteBackgroundColors), borderColor: background !== "white"
                    ? getColor(i, barDarkBackgroundColors)
                    : getColor(i, barWhiteBackgroundColors) }, e))) }), plugins: [getBackGroundPlugin(background)], 
        // @ts-ignore
        options: {
            plugins: {
                tooltip: Object.assign(Object.assign({}, defaultTooltipProps), tooltip),
                title: Object.assign({}, chartDefaults(background, title, {
                    titlePosition,
                    legendPosition,
                }).title),
                legend: Object.assign(Object.assign({}, chartDefaults(background, title, {
                    titlePosition,
                    legendPosition,
                }).legend), { display: showLegend }),
            },
            scales: {
                x: {
                    grid: {
                        display: showAxisX && showGridX && alignment === "horizontal",
                        color: gridColor(background),
                        tickColor: background !== "white" ? "rgba(255,255,255,0.5)" : "#CCCCCC",
                        drawTicks: true,
                        // @ts-ignore
                        drawBorder: false,
                    },
                    ticks: {
                        display: showAxisX,
                        color: background !== "white" ? "rgba(255,255,255,0.8)" : "#707070",
                    },
                    title: {
                        text: xAxistitle,
                        display: showAxisX && alignment === "horizontal",
                        color: background !== "white" ? "rgba(255,255,255,0.8)" : "#707070",
                    },
                },
                y: {
                    grid: {
                        display: showAxisY && showGridY && alignment === "vertical",
                        // @ts-ignore
                        drawBorder: false,
                        color: gridColor(background),
                        tickColor: background !== "white" ? "rgba(255,255,255,0.5)" : "#CCCCCC",
                        borderDashOffset: 0,
                    },
                    ticks: {
                        display: showAxisY,
                        color: background !== "white" ? "rgba(255,255,255,0.8)" : "#707070",
                        padding: 8,
                    },
                    title: {
                        text: yAxistitle,
                        display: showAxisY && alignment === "vertical",
                        color: background !== "white" ? "rgba(255,255,255,0.8)" : "#707070",
                    },
                },
                y1: {
                    display: showAxisY1 &&
                        showGridY1 &&
                        (typeof data !== "function" ? data.datasets : []).some((s) => s.yAxisID === "y1"),
                    position: "right",
                    type: "linear",
                    grid: {
                        // @ts-ignore
                        drawBorder: false,
                        drawOnChartArea: false,
                        drawTicks: false,
                    },
                    ticks: {
                        display: showAxisY1,
                        color: background !== "white" ? "rgba(255,255,255,0.8)" : "#707070",
                    },
                    title: {
                        text: y1Axistitle,
                        display: showAxisY1 && alignment === "vertical",
                        color: background !== "white" ? "rgba(255,255,255,0.8)" : "#707070",
                    },
                },
            },
            layout: {
                padding: { left: 10, top: 25, right: 30, bottom: 20 },
            },
            indexAxis: alignment === "horizontal" ? "y" : "x",
        } })));
});
Bar.displayName = "Bar";
